<template>
  <div class="student">
    <el-card class="box-card" style="margin-top: 0px">
      <div style="position:relative;">
        <el-tabs v-model="activeName" @tab-click="handleClick">
          <el-tab-pane :label="item.label" :name="item.name" v-for="(item, k) in catogeryList" :key="k">
          </el-tab-pane>
        </el-tabs>
        <el-button type="primary" icon="el-icon-plus" size="mini" class="addPoint" @click="addFormVisible = true, addNewPoint()">添加知识点</el-button>
      </div>
      <el-table ref="multipleTable" v-loading="loading" element-loading-text="拼命加载中" element-loading-background="rgba(255, 255, 255, 0.8)" :data="page.rows" tooltip-effect="dark" style="margin-top: 0px; width: 100%" border @selection-change="selectionChange">
        <!-- <el-table-column type="selection" width="55"></el-table-column> -->
        <el-table-column prop="type" label="分类" width="150px"></el-table-column>
        <el-table-column prop="url" label="视频" width="130px">
          <template slot-scope="scope">
            <video :src="scope.row.url" style="width:107px;height:80px;"></video>
          </template>
        </el-table-column>
        <el-table-column prop="mobile" label="封面" width="130px">
          <template slot-scope="scope">
            <img :src="scope.row.img" alt="" style="width:107px;height:80px;" srcset="">
          </template>
        </el-table-column>
        <el-table-column prop="goodsInfos" label="备注" minWidth="250px">
          <template slot-scope="scope">
            <el-tooltip :open-delay="300" class="item" effect="dark" :content="scope.row.remark">
              <div class="answer">
                {{ scope.row.remark || ' ' }}
              </div>
            </el-tooltip>
          </template>
        </el-table-column>
        <el-table-column prop="mobile" label="播放量" width="120px">
          <template slot-scope="scope">
            <span class="mainColor">{{ scope.row.volume || 0 }}</span>
          </template>
        </el-table-column>
        <el-table-column prop="name" label="创建人" width="120px"></el-table-column>
        <el-table-column prop="createTime" label="创建时间" width="150px"></el-table-column>
        <el-table-column prop label="操作" width="200" align="center" fixed="right">
          <template slot-scope="scope">
            <div class="operationGroup">
              <span class="mainColor" @click="(selection = scope.row.id), clickRow = scope.row, (editFormVisible = true)">编辑</span>
              <span class="mainColor" @click="deletePoint(scope.row)">删除</span>
              <el-switch v-model="scope.row.enable" :active-value="1" :inactive-value="-1" @change="updateSwitching(scope.row)" class="switchStyle" active-text="开" inactive-text="关"></el-switch>
            </div>
          </template>
        </el-table-column>
      </el-table>
      <el-pagination background layout="total, prev, pager, next" style="margin-top: 20px; text-align: right" :total="page.total" :page-size="page.pageSize" :current-page="page.pageNumber" @size-change="sizeChange" @current-change="currentChange"></el-pagination>
    </el-card>

    <el-dialog title="添加知识点" :visible.sync="addFormVisible" width="50%" left>
      <el-form ref="addForm" :model="addForm" :label-width="formLabelWidth" :rules="addFormRules">
        <el-row :span="24">
          <el-col :sm="24" :md="12" :lg="24">
            <el-form-item label="上传视频" prop="videoUrl" v-loading="loadVideo">
              <div>
                <el-upload class="avatar-uploader-logo" action :show-file-list="false" ref="upload" :http-request="videoUrlUploadRequest1">
                  <i class="el-icon-plus avatar-uploader-icon"></i>
                  <video class="currencySetting-image" style="margin-left: 20px" v-if="addForm.videoUrl" :src="addForm.videoUrl" height="60" width="108"></video>
                </el-upload>
                <div class="paySetting-tips">
                  支持mp4、avi、wmv格式，大小不超过2GB
                </div>
              </div>
            </el-form-item>
          </el-col>
        </el-row>
        <el-row :span="24">
          <el-col :sm="24" :md="12" :lg="24">
            <el-form-item label="上传封面" prop="posterUrl">
              <div>
                <el-upload class="avatar-uploader-logo" action :show-file-list="false" ref="upload" :http-request="posterUploadRequest1">
                  <i class="el-icon-plus avatar-uploader-icon"></i>
                  <img class="currencySetting-image" style="margin-left: 20px" v-if="addForm.posterUrl" :src="addForm.posterUrl" height="60" width="60" />
                </el-upload>
                <div class="paySetting-tips">
                  图片大小不超过1M，仅支持jpg，png格式，最佳尺寸为250*60.
                </div>
              </div>
            </el-form-item>
          </el-col>
        </el-row>
        <el-row :span="24">
          <el-col :sm="24" :md="12" :lg="24">
            <el-form-item label="视频备注" prop="remark">
              <el-input type="textarea" :rows="3" v-model="addForm.remark" placeholder="请输入视频备注" auto-complete="off" maxlength="200"></el-input>
            </el-form-item>
          </el-col>
        </el-row>
        <el-row :span="24">
          <el-col :sm="24" :md="12" :lg="24">
            <el-form-item label="视频分类" prop="type">
              <el-select v-model="addForm.type" placeholder="请选择">
                <el-option v-for="item in catogeryList" :key="item.name" :label="item.label" :value="item.label">
                </el-option>
              </el-select>
            </el-form-item>
          </el-col>
        </el-row>
      </el-form>
      <div style="height: 40px">
        <div slot="footer" class="dialog-footer" style="float: right">
          <el-button @click="addFormVisible = false">取 消</el-button>
          <el-button type="primary" @click="addStudent">确 定</el-button>
        </div>
      </div>
    </el-dialog>

    <el-dialog title="编辑知识点" :visible.sync="editFormVisible" width="50%" left>
      <el-form ref="editForm" :model="editForm" :label-width="formLabelWidth" :rules="editFormRules">
        <el-row :span="24">
          <el-col :sm="24" :md="12" :lg="24">
            <el-form-item label="上传视频" prop="videoUrl" v-loading="loadVideo">
              <div>
                <el-upload class="avatar-uploader-logo" action :show-file-list="false" ref="upload" :http-request="videoUrlUploadRequest">
                  <i class="el-icon-plus avatar-uploader-icon"></i>
                  <video class="currencySetting-image" style="margin-left: 20px" v-if="editForm.videoUrl" :src="editForm.videoUrl" height="60" width="108"></video>
                </el-upload>
                <div class="paySetting-tips">
                  支持mp4、avi、wmv格式，大小不超过2GB
                </div>
              </div>
            </el-form-item>
          </el-col>
        </el-row>
        <el-row :span="24">
          <el-col :sm="24" :md="12" :lg="24">
            <el-form-item label="上传封面" prop="posterUrl">
              <div>
                <el-upload class="avatar-uploader-logo" action :show-file-list="false" ref="upload" :http-request="posterUploadRequest">
                  <i class="el-icon-plus avatar-uploader-icon"></i>
                  <img class="currencySetting-image" style="margin-left: 20px" v-if="editForm.posterUrl" :src="editForm.posterUrl" height="60" width="60" />
                </el-upload>
                <div class="paySetting-tips">
                  图片大小不超过1M，仅支持jpg，png格式，最佳尺寸为250*60.
                </div>
              </div>
            </el-form-item>
          </el-col>
        </el-row>
        <el-row :span="24">
          <el-col :sm="24" :md="12" :lg="24">
            <el-form-item label="视频备注" prop="remark">
              <el-input type="textarea" :rows="3" v-model="editForm.remark" placeholder="请输入视频备注" auto-complete="off" maxlength="200"></el-input>
            </el-form-item>
          </el-col>
        </el-row>
        <el-row :span="24">
          <el-col :sm="24" :md="12" :lg="24">
            <el-form-item label="视频分类" prop="type">
              <el-select v-model="editForm.type" placeholder="请选择">
                <el-option v-for="item in catogeryList" :key="item.name" :label="item.label" :value="item.label">
                </el-option>
              </el-select>
            </el-form-item>
          </el-col>
        </el-row>
      </el-form>
      <div slot="footer" class="dialog-footer" style="text-align: right">
        <el-button @click="editFormVisible = false">取 消</el-button>
        <el-button type="primary" @click="updateStudent">确 定</el-button>
      </div>
    </el-dialog>
  </div>
</template>

<script>
import { mapGetters } from "vuex";
import md5 from "md5";
import { uploadOSS } from "../../upload/upload";
import video from '../classRoomTeaching/video.vue';
export default {
  components: { video },
  data () {
    return {
      loadVideo: false,
      groupList: [],
      subjectList: [],
      campusList: [],
      subjectListVisible: false,
      page: {
        rows: [],
        total: 0,
        pageSize: 10,
        pageNumber: 1,
        sortName: "",
        sortOrder: "",
      },
      viewFormVisible: false,
      addFormVisible: false,
      editFormVisible: false,
      importFormVisible: false,
      options: [],
      region: [],
      campusTreeProps: {
        value: "id",
        label: "name",
        children: "children",
      },
      searchForm: {
        studentGroupIds: [],
        name: "",
        account: "",
        fromType: "",
        createTime: "",
        showAllTate: "1",
      },
      regionTreeProps: {
        value: "id",
        label: "name",
        children: "children",
      },
      addForm: {
        videoUrl: '',
        posterUrl: '',
        remark: '',
        type: '',
      },
      addFormRules: {
        posterUrl: [
          {
            required: true,
            message: "请上传视频",
            trigger: "blur",
          },
        ],
        videoUrl: [
          {
            required: true,
            message: "请上传视频封面",
            trigger: "blur",
          },
        ],
        remark: [
          {
            required: true,
            message: "请输入视频备注",
            trigger: "blur",
          },
          {
            min: 1,
            max: 255,
            message: "视频备注长度在1到255个字",
          },
        ],
        type: [
          {
            required: true,
            message: "请选择视频分类",
            trigger: "blur",
          }
        ],
      },
      editForm: {
        videoUrl: '',
        posterUrl: '',
        remark: '',
        type: '',
      },
      studentDetail: {},
      editFormRules: {
        posterUrl: [
          {
            required: true,
            message: "请上传视频",
            trigger: "blur",
          },
        ],
        videoUrl: [
          {
            required: true,
            message: "请上传视频封面",
            trigger: "blur",
          },
        ],
        remark: [
          {
            required: true,
            message: "请输入视频备注",
            trigger: "blur",
          },
          {
            min: 1,
            max: 255,
            message: "视频备注长度在1到255个字",
          },
        ],
        type: [
          {
            required: true,
            message: "请选择视频分类",
            trigger: "blur",
          }
        ],
      },
      importForm: {},
      formLabelWidth: "80px",
      selection: "",
      multipleSelection: "",
      regionList: [],
      ids: [],
      fileAction: `${process.env.BASE_URL}/student/upload`,
      fileList: [],
      studentGroupLIst: [],
      loading: false,
      exportLoading: false,
      activeName: 'first',
      switchType: '全部',
      clickRow: {},
      catogeryList: [
        {
          label: '其他',
          name: 'first'
        }, {
          label: '会计',
          name: 'second'
        }, {
          label: '电脑',
          name: 'three'
        }, {
          label: '职业资格',
          name: 'four'
        }, {
          label: '学历',
          name: 'five'
        }
      ]
    };
  },
  computed: {
    ...mapGetters(["loginData"]),
    reqData () {
      return this.$store.state.user;
    },
  },
  methods: {
    addNewPoint () {
      this.addForm = {
        videoUrl: '',
        posterUrl: '',
        remark: '',
        type: '',
      }
      console.log(this.addForm, 'addNewPoint')
    },
    handleClick (e) {
      console.log(e)
      this.switchType = e.label
      this.page.pageNumber = 1;
      this.pageList();
    },

    campusChange (val) {
      this.searchForm.campusId = val[2];
    },
    // 是否启用
    updateSwitching (row) {
      var params = {
        enable: row.enable,
        id: row.id
      }
      this.api.classroom.updateKnowledgePoint(params).then((result) => {
        if (result.success) {
          this.$message({
            type: "success",
            message: result.message,
          });
          this.pageList();
        } else {
          this.$message.error(result.message);
        }
      }).catch((error) => {
        console.log(error);
      });
    },
    seeOverviewDetails (obj) {
      this.$router.push(`/studentGoodsContent?id=${obj.id}`);
    },
    importExcel () {
      window.open(
        // "https://68wx--test.oss-cn-hangzhou.aliyuncs.com/student/%E5%AD%A6%E7%94%9F%E4%B8%8A%E4%BC%A0%E6%A8%A1%E6%9D%BF.xls"
        "http://68wx--test.oss-cn-hangzhou.aliyuncs.com/materials/16190125872036.xls"
      );
    },
    addRegionChange () {
      this.addForm.regionId = this.region[1];
    },
    editRegionChange () {
      this.editForm.regionId = this.region[1];
    },
    getPageList (id) {
      this.api.classroom.getPointList({ id: id })
        .then((result) => {
          if (result.data) {
            this.subjectList = result.data;
          } else {
            this.subjectList = [];
          }
          this.subjectListVisible = true;
        })
        .catch((error) => {
          console.log(error);
        });
    },
    sizeChange (pageSize) {
      this.page.pageSize = pageSize;
      this.pageList();
    },

    currentChange (pageNumber) {
      this.page.pageNumber = pageNumber;
      this.pageList();
    },
    selectionChange (val) {
      console.log("val", val);
      this.multipleSelection = val;
      val.map((e) => this.ids.push({ id: e.id }));
      console.log("this.ids", this.ids);
    },
    getStudent () {
      console.log(this.clickRow)
      this.editForm = this.clickRow;
      // this.editForm.posterUrl = this.clickRow.img
      // this.editForm.videoUrl = this.clickRow.url
      this.$set(this.editForm, 'posterUrl', this.clickRow.img)
      this.$set(this.editForm, 'videoUrl', this.clickRow.url)
    },
    getStudentDetail () {
      this.api.student.getStudentDetail({
        id: this.selection,
      }).then((result) => {
        this.studentDetail = result.data;
      }).catch((error) => {
        console.log(error);
      });
    },
    pageList () {
      this.loading = true;
      var params = {
        pageSize: this.page.pageSize,
        pageNumber: this.page.pageNumber,
        type: this.switchType == '全部' || this.switchType == '其他' ? '' : this.switchType,
      }
      this.api.classroom.getPointList(params).then((result) => {
        this.loading = false;
        this.page.rows = result.data.records;
        this.page.total = result.data.total;
      }).catch((error) => {
        console.log(error);
      });
    },
    addStudent () {
      this.$refs.addForm.validate((valid) => {
        if (valid) {
          var params = {
            img: this.addForm.posterUrl,
            remark: this.addForm.remark,
            type: this.addForm.type,
            url: this.addForm.videoUrl,
          }
          this.api.classroom.addKnowledgePoint(params).then((result) => {
            if (result.success) {
              this.$message.success(result.message);
              this.addFormVisible = false;
            } else {
              this.$message.error(result.message);
            }
          })
        } else {
          return false;
        }
      });
    },
    updateStudent () {
      this.$refs.editForm.validate((valid) => {
        if (valid) {
          this.editForm.img = this.editForm.posterUrl
          this.editForm.url = this.editForm.videoUrl
          delete this.editForm.posterUrl
          delete this.editForm.videoUrl
          this.api.classroom.updateKnowledgePoint(this.editForm).then((result) => {
            if (result.success) {
              this.$message({
                type: "success",
                message: result.message,
              });
              this.editFormVisible = false;
              this.pageList();
            } else {
              this.$message.error(result.message);
            }
          })
            .catch((error) => {
              console.log(error);
            });
        } else {
          return false;
        }
      });
    },
    deletePoint (obj) {
      this.$confirm("您确定要进行删除操作吗？", "系统消息", {
        type: "warning",
      }).then(() => {
        var params = {
          "id": obj.id,
          "state": -1
        }
        this.api.classroom.updateKnowledgePoint(params).then((result) => {
          if (result.success) {
            this.$message({
              type: "success",
              message: result.message,
            });
            this.pageList();
          } else {
            this.$message.error(result.message);
          }
        })
      })
    },
    batchDeleteStudent () {
      this.$confirm("您确定要进行删除操作吗？", "系统消息", {
        type: "warning",
      })
        .then(() => {
          this.api.student
            .deleteStudent(this.ids)
            .then((result) => {
              if (result.success) {
                this.$message({
                  type: "success",
                  message: result.message,
                });
                this.pageList();
              } else {
                this.$message.error(result.message);
              }
            })
            .catch((error) => {
              console.log(error);
            });
        })
        .catch(() => { });
    },
    reset () {
      this.searchForm.studentGroupIds = [];
      this.$refs.searchForm.resetFields();
      this.page.pageSize = 10;
      this.page.pageNumber = 1;
      this.page.sortName = "";
      this.page.sortOrder = "";
      this.page = {
        rows: [],
        total: 0,
        pageSize: 10,
        pageNumber: 1,
        sortName: "",
        sortOrder: "",
      };
      this.pageList();
    },
    handleSuccess (response, file, fileList, $event) {
      this.importForm = response.data;
    },
    exportExcel () {
      this.exportLoading = true;
      setTimeout(() => {
        this.exportLoading = false;
      }, 5000);
      let obj = Object.assign({}, this.searchForm);
      delete obj.createTime;
      this.api.student
        .exportExcel(obj)
        .then((result) => {
          if (result.success) {
            let url = result.data;
            this.$message.success(url);
            this.exportLoading = false;
          } else {
            this.exportLoading = false;
            this.$message.error(result.message);
          }
        })
        .catch((error) => {
          this.exportLoading = false;
          console.log(error);
        });
    },
    resetStudentPassword (row) {
      this.$confirm("您确定要重置密码吗？", "系统消息", {
        type: "warning",
      }).then(() => {
        this.api.student
          .resetStudentPassword({ id: row.id })
          .then((result) => {
            if (result.success) {
              this.$message.success("操作成功，密码为您的手机号！");
            } else {
              this.$message.error(result.message);
            }
          })
          .catch((error) => {
            console.log(error);
          });
      });
    },
    goOpen (row) {
      this.$router.push({
        path: "/open",
        query: {
          phone: row ? row.account : "",
          id: row ? row.id : "",
        },
      });
    },
    importData () {
      if (this.multipleSelection.length == 0) {
        this.$message("请选择需要导入的学员");
      } else {
        this.api.student
          .importData(this.multipleSelection)
          .then((result) => {
            this.$message({
              type: "success",
              message: result.message,
            });
            this.multipleSelection = [];
            this.pageList();
            this.importFormVisible = false;
          })
          .catch((error) => {
            console.log(error);
          });
      }
    },
    getCampusList () {
      this.api.campus
        .getCampusTree({ parentId: 1 })
        .then((result) => {
          for (let item of result.data) {
            if (item.children.length != 0) {
              for (let items of item.children) {
                if (items.children.length != 0) {
                  for (let itemss of items.children) {
                    if (itemss.children.length != 0) {
                      delete itemss.children;
                    } else {
                      delete itemss.children;
                    }
                  }
                } else {
                  delete items.children;
                }
              }
            } else {
              delete item.children;
            }
          }
          this.campusList = result.data;
        })
        .catch((error) => {
          console.log(error);
        });
    },
    getRegionTree () {
      this.api.getRegionTree().then((result) => {
        if (result.success) {
          this.regionList = result.data;
        }
      });
    },
    getStudentGroupList () {
      this.api.student
        .getStudentGroupList({})
        .then((result) => {
          this.groupList = result.data;
        })
        .catch((error) => {
          console.log(error);
        });
      this.api.student
        .getStudentFromTypeList({})
        .then((result) => {
          this.options = result.data;
        })
        .catch((error) => {
          console.log(error);
        });

      this.api.student
        .getStudentGroupList({})
        .then((result) => {
          this.studentGroupLIst = result.data;
        })
        .catch((error) => {
          console.log(error);
        });
    },
    checkboxT (row, rowIndex) {
      if (row.remark == "") {
        return true;
      } else {
        return false;
      }
    },
    videoUrlUploadRequest (file) {
      console.log("file", file);
      this.loadVideo = true
      const isJPG = file.file.type === "video/mp4" || file.file.type === "video/avi" || file.file.type === "video/wmv";
      if (!isJPG) {
        this.$message.error("上传视频只支持mp4、avi、wmv格式!");
        this.loadVideo = false
        return;
      }
      if (file.file.size / 1024 / 1024 > 2000) {
        this.loadVideo = false
        this.$message.error("视频大小不能超过2G");
        return;
      } else {
        uploadOSS(file, "generalSetting").then((result) => {
          this.$set(this.editForm, "videoUrl", result);
          console.log(result)
          this.loadVideo = false
        });
      }
      this.loadVideo = false
    },
    posterUploadRequest (file) {
      console.log("file", file);
      const isJPG = file.file.type === "image/jpeg" || file.file.type === "image/png";
      if (!isJPG) {
        this.$message.error("上传头像图片只能是 JPG/png 格式!");
        return;
      }
      if (file.file.size / 1024 / 1024 > 1) {
        this.$message.error("图片大小不能超过1M");
        return;
      } else {
        uploadOSS(file, "generalSetting").then((result) => {
          this.$set(this.editForm, "posterUrl", result);
        });
      }
    },
    videoUrlUploadRequest1 (file) {
      this.loadVideo = true
      console.log("file", file);
      const isJPG = file.file.type === "video/mp4" || file.file.type === "video/avi" || file.file.type === "video/wmv";
      if (!isJPG) {
        this.$message.error("上传视频只支持mp4、avi、wmv格式!");
        this.loadVideo = false
        return;
      }
      if (file.file.size / 1024 / 1024 > 2000) {
        this.loadVideo = false
        this.$message.error("视频大小不能超过2G");
        return;
      } else {
        uploadOSS(file, "generalSetting").then((result) => {
          this.$set(this.addForm, "videoUrl", result);
          console.log(result)
          this.loadVideo = false
        });
      }
      this.loadVideo = false
    },
    posterUploadRequest1 (file) {
      console.log("file", file);
      const isJPG = file.file.type === "image/jpeg" || file.file.type === "image/png";
      if (!isJPG) {
        this.$message.error("上传头像图片只能是 JPG/png 格式!");
        return;
      }
      if (file.file.size / 1024 / 1024 > 1) {
        this.$message.error("图片大小不能超过1M");
        return;
      } else {
        uploadOSS(file, "generalSetting").then((result) => {
          this.$set(this.addForm, "posterUrl", result);
        });
      }
    },
  },
  watch: {
    "searchForm.createTime": function (newVal) {
      if (newVal) {
        this.searchForm.beginDate = newVal[0];
        this.searchForm.endDate = newVal[1];
      } else {
        this.searchForm.createTime = [];
        this.searchForm.beginDate = "";
        this.searchForm.endDate = "";
      }
    },
    addFormVisible: function (newVal) {
      if (!newVal) {
        this.$refs.addForm.resetFields();
        this.pageList();
      } else {
      }
      console.log(this.addForm, 'addFormVisible')
    },
    editFormVisible: function (newVal) {
      if (!newVal) {
        this.$refs.editForm.resetFields();
        this.pageList();
      } else {
        this.getStudent();
      }
    },
    importFormVisible: function (newVal) {
      if (!newVal) {
        this.importForm = {};
      } else {
      }
    },
    viewFormVisible: function (newVal) {
      if (!newVal) {
        this.studentDetail = {};
        this.$refs.studentDetail.resetFields();
      } else {
        this.getStudentDetail();
      }
    },

  },
  mounted () {
    this.pageList();
    this.getStudentGroupList();
    this.getCampusList();
  },
};
</script>
<style scoped>
.addPoint {
  position: absolute;
  right: 0;
  top: 0;

}

.avatar-uploader-logo {
  margin-top: 20px;
}

.avatar-uploader-logo .el-upload {
  border: 1px dashed #d9d9d9 !important;
  border-radius: 6px;
  cursor: pointer;
  position: relative;
  overflow: hidden;
}

.avatar-uploader-logo .el-upload:hover {
  border-color: #409eff;
}

.avatar-uploader-icon {
  font-size: 28px;
  color: #8c939d;
  width: 60px;
  height: 60px;
  line-height: 60px;
  text-align: center;
  border: 1px dashed #d9d9d9 !important;
  border-radius: 6px;
}

.avatar {
  width: 60px;
  height: 60px;
  display: block;
}

.currencySetting-image {
  border-radius: 4px;
  vertical-align: bottom;
}

.answer {
  width: 130px;
  white-space: nowrap;
  overflow: hidden;
  color: #409eff;
  text-overflow: ellipsis;
}

.courseManage {
  padding: 3px 14px 3px 14px;
  color: #fff;
  text-align: center;
  border-radius: 4px;
}

.style1 {
  background: rgb(36, 210, 181);
  border: solid 1px rgb(36, 210, 181);
}

.style2 {
  background: rgb(255, 185, 28);
  border: solid 1px rgb(255, 185, 28);
}

.style3 {
  background: rgb(162, 170, 188);
  border: solid 1px rgb(162, 170, 188);
}
</style>
<style lang="less">
.student {
  .el-select {
    width: 100% !important;
  }

  .viewForm {
    .el-dialog__body {
      padding-top: 0px;
    }

    .el-form-item {
      margin-bottom: 0px !important;
    }
  }

  .importForm {
    .el-upload-list {
      display: none !important;
    }
  }
}
</style>



// WEBPACK FOOTER //
// src/components/registerGuide/registerKnowlegePoint.vue